import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ContentLoading, ErrorPage } from 'axway-react-ui';
import browserHistory from 'components/utility/history';
import * as actions from '../actions';
import ConfigurationEditorView from '../view/ConfigurationEditorView';

class ConfigurationEditor extends React.Component {
	constructor(props) {
		super(props);
		this.cancel = this.cancel.bind(this);
		this.closeErrorDialog = this.closeErrorDialog.bind(this);
		this.save = this.save.bind(this);
	}

	save(config) {
		this.props.actions.saveConfig(config);
	}

	cancel() {
		browserHistory.push(`${window.$conf.prefix}/project/configuration`);
	}

	closeErrorDialog() {
		this.props.actions.clearConfigError();
	}

	render() {
		const { saving, error, errorDetail, config, loading } = this.props;
		if (!saving && error) {
			return (
				<ErrorPage errorDetail={errorDetail} />
			);
		} else if (config && !loading) {
			return (
				<ConfigurationEditorView
					item={config}
					onCancel={this.cancel}
					onSave={this.save}
					saving={saving}
					error={error}
					errorDetail={errorDetail}
					closeErrorDialog={this.closeErrorDialog}
				/>
			);
		}
		return <ContentLoading />;
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

function mapStateToProps(state) {
	return {
		loading: state.config.loading,
		saving: state.config.saving,
		config: state.config.config,
		error: state.config.error,
		errorDetail: state.config.errorDetail
	};
}

ConfigurationEditor.propTypes = {
	loading: PropTypes.bool,
	config: PropTypes.object,
	saving: PropTypes.bool,
	error: PropTypes.bool,
	errorDetail: PropTypes.object
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ConfigurationEditor);
